import React, { forwardRef } from 'react';
import { PropTypes } from '../../../utils/propTypes';
import styles from './Textarea.module.css';

/**
 * Textarea — the shared 2.0 multi-line text control. Mirrors Input's flat 2.0
 * styling (border / bg / focus-ring / disabled / aria-invalid + [data-theme]
 * overrides) but is multi-line (min-height + vertical resize). Forwards all
 * native props (disabled, aria-invalid, placeholder, rows, …). Preview-only.
 */
const Textarea = forwardRef(({ rows = 3, className = '', ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    data-slot="textarea"
    className={`${styles.textarea} ${className}`.trim()}
    {...props}
  />
));

Textarea.displayName = 'Textarea';

Textarea.propTypes = {
  rows: PropTypes.number,
  className: PropTypes.string,
};

export default Textarea;
export { Textarea };
